// extracted by mini-css-extract-plugin
export default {"Subpage":"costs_Subpage__hr+qe","CostSection":"costs_CostSection__sgZvv"};